// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ripple {
  0% {
    box-shadow: 0px 0px 0px 0.07rem rgba(0, 0, 0, 0);
  }
  50% {
    box-shadow: 0px 0px 0px 1.07rem rgba(0, 0, 0, 0.1);
  }
  100% {
    box-shadow: 0px 0px 0px 1.07rem rgba(0, 0, 0, 0);
  }
}
.Radio {
  margin: 0.7142857142857143rem 0;
  line-height: 1.2857142857142858rem;
}
.Radio input[type='radio'] {
  display: none;
}
.Radio input[type='radio']:checked + label:before {
  border-color: var(--palette-trovit-blue);
  animation: ripple 0.2s linear forwards;
}
.Radio input[type='radio']:checked + label:after {
  transform: scale(1);
}
.Radio label {
  display: inline-block;
  height: 1.4285714285714286rem;
  position: relative;
  padding: 0 2rem;
  margin-bottom: 0;
  cursor: pointer;
  vertical-align: bottom;
  font-weight: normal;
}
.Radio label:before,
.Radio label:after {
  position: absolute;
  content: '';
  border-radius: 50%;
  transition: all 0.3s ease;
  transition-property: transform, border-color;
}
.Radio label:before {
  left: 0;
  top: 0;
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  border: 0.14285714285714285rem solid rgba(0, 0, 0, 0.54);
}
.Radio label:after {
  top: 0.35714285714285715rem;
  left: 0.35714285714285715rem;
  width: 0.5714285714285714rem;
  height: 0.5714285714285714rem;
  transform: scale(0);
  background: var(--palette-trovit-blue);
}

.Radio input[type='radio']:checked:disabled + label:before {
  border-color: var(--palette-gray-7);
}

.Radio input[type='radio']:checked:disabled + label:after {
  background-color: var(--palette-gray-7);
}

.Radio input[type='radio']:disabled {
  boxShadow: 'none';
  background: gray;
}

.Radio input[type='radio']:disabled + label {
  color: gray;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/input/Radio/Radio.css"],"names":[],"mappings":"AAAA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,kDAAkD;EACpD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;AAC9C;AACA;EACE,OAAO;EACP,MAAM;EACN,4BAA4B;EAC5B,6BAA6B;EAC7B,wDAAwD;AAC1D;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":["@keyframes ripple {\n  0% {\n    box-shadow: 0px 0px 0px 0.07rem rgba(0, 0, 0, 0);\n  }\n  50% {\n    box-shadow: 0px 0px 0px 1.07rem rgba(0, 0, 0, 0.1);\n  }\n  100% {\n    box-shadow: 0px 0px 0px 1.07rem rgba(0, 0, 0, 0);\n  }\n}\n.Radio {\n  margin: 0.7142857142857143rem 0;\n  line-height: 1.2857142857142858rem;\n}\n.Radio input[type='radio'] {\n  display: none;\n}\n.Radio input[type='radio']:checked + label:before {\n  border-color: var(--palette-trovit-blue);\n  animation: ripple 0.2s linear forwards;\n}\n.Radio input[type='radio']:checked + label:after {\n  transform: scale(1);\n}\n.Radio label {\n  display: inline-block;\n  height: 1.4285714285714286rem;\n  position: relative;\n  padding: 0 2rem;\n  margin-bottom: 0;\n  cursor: pointer;\n  vertical-align: bottom;\n  font-weight: normal;\n}\n.Radio label:before,\n.Radio label:after {\n  position: absolute;\n  content: '';\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  transition-property: transform, border-color;\n}\n.Radio label:before {\n  left: 0;\n  top: 0;\n  width: 1.2857142857142858rem;\n  height: 1.2857142857142858rem;\n  border: 0.14285714285714285rem solid rgba(0, 0, 0, 0.54);\n}\n.Radio label:after {\n  top: 0.35714285714285715rem;\n  left: 0.35714285714285715rem;\n  width: 0.5714285714285714rem;\n  height: 0.5714285714285714rem;\n  transform: scale(0);\n  background: var(--palette-trovit-blue);\n}\n\n.Radio input[type='radio']:checked:disabled + label:before {\n  border-color: var(--palette-gray-7);\n}\n\n.Radio input[type='radio']:checked:disabled + label:after {\n  background-color: var(--palette-gray-7);\n}\n\n.Radio input[type='radio']:disabled {\n  boxShadow: 'none';\n  background: gray;\n}\n\n.Radio input[type='radio']:disabled + label {\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
